<template>
  <div>
    <mean-of-telecom-modal
      v-if="isPowerUserOrAdministrator"
      :show="showMeanOfTelecomModal"
      :current-operation="currentOperation"
      :mean-of-telecom="meanOfTelecom"
      :type="type"
      @close="closeMeanOfTelecomModal"
    />

    <p>
      Liste des moyens de communication
      <button
        v-show="!editingDisabled"
        id="btn-add"
        type="button"
        class="btn btn-icon btn-round btn-success"
        aria-label="Ajouter un moyen de communication"
        @click="createMeanOfTelecom"
      >
        <i class="fa fa-plus" />
      </button>
    </p>
    <div class="row text-left">
      <div
        v-for="(meanOfTelecom, index) in meansOfTelecom"
        :key="index"
        class="col-md-3"
      >
        <div
          :class="{ 'clickable-element': !editingDisabled }"
          class="meanoftelecom-card"
          @click="meanOfTelecomCardClicked(meanOfTelecom, $event)"
        >
          <b>
            {{
              removeAnnuaireAndDefautValuesFromStringIfNotConnected(
                meanOfTelecom.meanOfTelecom.mocName,
              )
            }}
            <span v-if="meanOfTelecom.type">({{ meanOfTelecom.type }})</span>
          </b>
          <p>
            {{ meanOfTelecom.info }}
          </p>

          <div
            v-if="
              isConnected && meanOfTelecom.isDisplayedInPublicCommitteesList
            "
            class="label-displayed-in-public-lists"
          >
            <i class="fa fa-eye icon" />
            public
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  isConnected,
  isPowerUserOrAdministrator,
} from '@/services/AuthService';
import MixinUtils from '@/mixins/mixinUtils';
import MeanOfTelecomModal from 'src/components/ApplicationViews/Modals/MeanOfTelecomModal.vue';

export default {
  name: 'MeansOfTelecomCards',
  components: {
    MeanOfTelecomModal,
  },
  mixins: [MixinUtils],
  props: {
    meansOfTelecom: Array,
    editingDisabled: Boolean,
    type: String,
    linkedEntityId: Number,
    fetch: Function,
  },
  data() {
    return {
      showMeanOfTelecomModal: false,
      currentOperation: null,
      meanOfTelecom: {},
    };
  },
  computed: {
    isConnected,
    isPowerUserOrAdministrator,
  },
  methods: {
    meanOfTelecomCardClicked(meanOfTelecom, event) {
      if (this.editingDisabled) {
        event.stopPropagation();
      } else {
        this.currentOperation = 'edit';
        this.meanOfTelecom = {
          id: meanOfTelecom.id,
          linkedEntityId: this.linkedEntityId,
          mocId: meanOfTelecom.meanOfTelecom.mocId,
          type: meanOfTelecom.type,
          info: meanOfTelecom.info,
          isDisplayedInPublicCommitteesList:
            meanOfTelecom.isDisplayedInPublicCommitteesList,
        };

        this.showMeanOfTelecomModal = true;
      }
    },
    createMeanOfTelecom() {
      this.currentOperation = 'create';
      this.meanOfTelecom = {
        linkedEntityId: this.linkedEntityId,
      };
      this.showMeanOfTelecomModal = true;
    },
    closeMeanOfTelecomModal() {
      this.showMeanOfTelecomModal = false;
      this.fetch(this.linkedEntityId);
    },
  },
};
</script>

<style scoped lang="scss">
.meanoftelecom-card {
  background-color: lightskyblue;
  padding: 15px;
  border: none;
  border-radius: 5px;
  margin-bottom: 10px;
}

.label-displayed-in-public-lists {
  color: #555;
  display: flex;
  font-size: 0.85em;

  .icon {
    font-size: 1.5em;
    margin-right: 0.4em;
  }
}
</style>
